import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Breadcrumbs } from '@mui/material';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';
import { Capacitor } from '@capacitor/core';
import useRescuerDashboardActions from '../../../../hooks/useRescuerDashboardActions';
import routes from '../../../../routes';
import { StyledRescuerBreadcrumb, StyledRescuerTextBreadcrumb } from '../Components/StyledRescuerBreadcrumb';
import MyEnviroImpact from '../../rescuerDashboardDesktop/myFrus/Components/MyEnviroImpact';
import DateAndGranularityPicker, {
  dateRangeOptionsList,
} from '../../../../components/DateAndGranularityPicker/DateAndGranularityPicker';

const defaultDateRangeOptions = {
  last7Days: dateRangeOptionsList.last7Days,
  last90Days: dateRangeOptionsList.last90Days,
  thisWeek: dateRangeOptionsList.thisWeek,
  thisMonth: dateRangeOptionsList.thisMonth,
  thisYear: dateRangeOptionsList.thisYear,
};

const EnviroImpactBreadcrumb = () => (
  <Box boxShadow={0}>
    <Breadcrumbs aria-label="breadcrumb">
      <StyledRescuerBreadcrumb
        component={RouterLink}
        to={routes.index}
        label="Home"
        icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />} />
      <StyledRescuerTextBreadcrumb component="a" href="#" label="My Impact" />
    </Breadcrumbs>
  </Box>
);

const EnvironmentImpactDashboardMobileContainer = () => {
  const environmentImpactEntities = useSelector((state) => state.entities.environmentImpact);
  const environmentImpactLoading = environmentImpactEntities.inflight;
  const { fetchEnviromentImpact } = useRescuerDashboardActions();
  const [scrollPosition, setScrollPosition] = useState(0);
  const yOffset = 56;

  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
};

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Scroll to top on component render
    window.scrollTo(0, 0);
  }, []);

  const handleDateChange = (date) => {
    if (date) {
      const start = date?.startDate ? moment(date.startDate).format('YYYY-MM-DD') : null;
      const end = date?.endDate ? moment(date.endDate).format('YYYY-MM-DD') : null;

      fetchEnviromentImpact(false, start, end);
    } else {
      fetchEnviromentImpact(false);
    }
  };

  return (
    <>
      <EnviroImpactBreadcrumb />
      <Box sx={{ height: '100%', width: '100%', overflow: 'auto', backgroundColor: 'background.default' }}>
        <Box display="flex" pt={10} pb={4} overflow="scroll">
          <MyEnviroImpact
            isRescuer
            iconSize={86}
            isLoading={environmentImpactLoading}
            environmentImpact={environmentImpactEntities.all}
          />
        </Box>
        <Box
          py={2}
          sx={[
            {
              width: '100%',
              backgroundColor: 'background.paper',
              boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
              marginLeft: '-8px',
              paddingLeft: '8px',
            },
            scrollPosition >= yOffset && {
              position: 'fixed',
              top: `calc(56px + var(--ion-safe-area-top))`,
            },
            scrollPosition < yOffset && {
              position: 'absolute',
              top: Capacitor.isNativePlatform() ? `calc(112px + var(--ion-safe-area-top))` : 112,
            },
          ]}
        >
          <DateAndGranularityPicker
            showGranularity={false}
            customDateRangeOptions={{
              maxDate: moment().toDate(),
            }}
            defaultDateRange="all"
            dateRangeOptions={defaultDateRangeOptions}
            onChange={(state) => {
              handleDateChange(state.dateRange);
            }}
            showCustomDateRange
            showAllDateRange
            showOnlyDatesInLabel
          />
        </Box>
      </Box>
    </>
  );
};

export default EnvironmentImpactDashboardMobileContainer;
